function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useMemo } from 'react';
import Form from 'react-bootstrap/Form';
import { useGrid } from '../../hook';
import { onDoneTypeJSX } from 'donevent';
import { FilterType } from '../../../../common/utils/data';
import FilterTemplate from '../FilterTemplate';

const LIKE = ({
  type: filterType,
  dataIndex,
  md,
  sm,
  lg,
  xl,
  inColumn,
  isFilterParameter,
  onChange: CustomFilter,
  ...props
}) => {
  const type = isFilterParameter ? FilterType.PARAMETER : filterType === 'integer' ? FilterType.INTEGER : filterType === 'decimal' ? FilterType.DECIMAL : FilterType.LIKE;
  const {
    filterProps,
    filters
  } = useGrid();
  const {
    onChange
  } = filterProps({
    dataIndex,
    type,
    value: '{search}',
    autoSubmit: true
  });
  const {
    onBlur,
    ...doneEvent
  } = onDoneTypeJSX(CustomFilter || onChange, 1000);
  const filterData = useMemo(() => filters.find(filter => `${dataIndex}` === `${filter.dataIndex}` && filter.type === type), [filters]);

  const handleBlur = event => {
    if ((!!filterData?.value || !!event.target.value) && filterData?.value !== event.target.value) {
      (CustomFilter || onChange)(event);
    }
  };

  return /*#__PURE__*/React.createElement(FilterTemplate, {
    md: md,
    sm: sm,
    lg: lg,
    xl: xl,
    inColumn: inColumn
  }, /*#__PURE__*/React.createElement(Form.Control, _extends({
    key: filterData?.value,
    autoComplete: "new-password"
  }, props, {
    name: `${dataIndex}`,
    defaultValue: filterData?.value,
    onBlur: handleBlur
  }, doneEvent)));
};

export default LIKE;